export var ChatWidgetToneMap;
(function (ChatWidgetToneMap) {
    ChatWidgetToneMap["CalmAndNeutral"] = "Calm and Neutral";
    ChatWidgetToneMap["ProfessionalAndFormal"] = "Professional and Formal";
    ChatWidgetToneMap["EmpatheticAndSupportive"] = "Empathetic and Supportive";
    ChatWidgetToneMap["ConversationalAndFriendly"] = "Conversational and Friendly";
    ChatWidgetToneMap["ConciseAndInformational"] = "Concise and Informational";
    ChatWidgetToneMap["CompassionateAndReassuring"] = "Compassionate and Reassuring";
    ChatWidgetToneMap["ClientFocusedAndPersonalized"] = "Client-Focused and Personalized";
})(ChatWidgetToneMap || (ChatWidgetToneMap = {}));
export var ChatWidgetTone;
(function (ChatWidgetTone) {
    ChatWidgetTone["CalmAndNeutral"] = "CalmAndNeutral";
    ChatWidgetTone["ProfessionalAndFormal"] = "ProfessionalAndFormal";
    ChatWidgetTone["EmpatheticAndSupportive"] = "EmpatheticAndSupportive";
    ChatWidgetTone["ConversationalAndFriendly"] = "ConversationalAndFriendly";
    ChatWidgetTone["ConciseAndInformational"] = "ConciseAndInformational";
    ChatWidgetTone["CompassionateAndReassuring"] = "CompassionateAndReassuring";
    ChatWidgetTone["ClientFocusedAndPersonalized"] = "ClientFocusedAndPersonalized";
})(ChatWidgetTone || (ChatWidgetTone = {}));
//# sourceMappingURL=chat-widget.js.map